/** The teacher's own rate today for each role, so the per-shift amounts below make sense. */
import type { CurrentRate } from '../../../../api/staff-pay-rates';
import { PAY_RATE_ROLE_LABELS } from '../../../staff/pay-rates/pay-rate-format';

import MyRateValue from './MyRateValue';

export default function MyRatesCard({ rates }: { rates: CurrentRate[] }) {
  return (
    <section
      aria-label="Your rates"
      className="nb-card"
      style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
    >
      <header className="nb-card-hd">
        <h3>Your rates</h3>
      </header>
      <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 16px' }}>
        {rates.map((rate) => (
          <div key={rate.role} style={{ display: 'contents' }}>
            <dt style={{ fontSize: 12, color: 'var(--nb-subtle)' }}>
              {PAY_RATE_ROLE_LABELS[rate.role]}
            </dt>
            <dd style={{ margin: 0, fontSize: 12 }}>
              <MyRateValue rate={rate} />
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
